<template>
  <template-tabs />
</template>

<script>
import TemplateTabs from '../../components/access/TemplateCases/TemplateTabs';

export default {
  name: 'templates',
  components: {
    TemplateTabs,
  },
};
</script>

<style scoped>
</style>